var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('VueShowdown',{attrs:{"markdown":_vm.content,"flavor":"github","options":{ emoji: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }